import React from 'react';
import { ResponsiveBar } from '@nivo/bar'
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const MyResponsiveBar = ({ data /* see data tab */ }) => {
  return (
    <ResponsiveBar
      data={data}
      keys={[ 'like' ]}
      indexBy="place"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}      
      colors={({ id, data }) => data.color}
      defs={[
        {
          id: 'gradient',
          type: 'linearGradient',
          colors: [
            { offset: 0, color: 'inherit' },
            { offset: 100, color: 'inherit', opacity: 0.5 },
          ],
        }
      ]}
      fill={[
          {match: '*', id: 'gradient'},
      ]}
      borderRadius={3}
      borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Place',
          legendPosition: 'middle',
          legendOffset: 32
      }}
      axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Like',
          legendPosition: 'middle',
          legendOffset: -40
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
      legends={[]}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      tooltip={({ id, value, index, color, data}) => (
        <p style={{ 'color': data.color, 'fontSize': '.8em' }}>{data.picture} : {data.like}</p>              
      )}
      theme={{
        tooltip: {
          container: {
            background: 'rgba(51,51,51, .9)',
          },
        },
      }}
    />
  )
}

export default MyResponsiveBar;
